import { useCallback, useMemo } from 'react';

import { SelectProps } from './Select.decl';

import { Select as TractorSelect, OptionTypeBase, SingleValue } from '@aircall/tractor';

/**
 * Wrapper for Tractor Select for custom behavior
 */
export function Select<OptionType extends OptionTypeBase>(props: SelectProps<OptionType>) {
  const { value, options, onChange, getOptionValue } = props;

  // this code would be replicated everywhere in the codebase
  // an exception would be if the value of the option is not in the option.value key
  // for this a custom function like "getOptionValue" out suffice
  const selectedValue = useMemo(() => {
    if (value === undefined || value === null) {
      return null;
    }
    // automatically gets the selected value from the options list

    return (options as OptionType[])?.find((option: OptionType) => {
      const optionValue = getOptionValue
        ? option && getOptionValue?.(option)
        : (option as OptionTypeBase)?.value;

      return optionValue === value;
    });
  }, [getOptionValue, options, value]);

  const onChangeHandler = useCallback(
    (selected: SingleValue<OptionType>) => {
      const optionValue = getOptionValue
        ? selected && getOptionValue?.(selected)
        : (selected as OptionTypeBase)?.value;
      onChange?.(optionValue);
    },
    [getOptionValue, onChange]
  );
  return <TractorSelect {...props} value={selectedValue} onChange={onChangeHandler} />;
}
